module.exports = __webpack_public_path__ + "img/B.bfa4325.webp";